'use strict';

/* global angular */

angular.module('atex.aceui.service').factory('WorkflowService',
  ['$q', '$rootScope', 'ApplicationConfigurationService', 'AuthenticationService',
    function WorkflowService ($q, $rootScope, ApplicationConfigurationService, AuthenticationService) {
      let serviceHandler;

      let handler = function () {
        if (serviceHandler !== undefined) {
          return $q.when(serviceHandler);
        }

        return ApplicationConfigurationService.getServiceConfigurationFor('WorkflowService').then(function (configuration) {
          let serviceUrl = atex.aceui.ServiceUtils.calculateServiceUrl(configuration, 'content-service/workflow');

          let serviceSettings = { customQ: atex.aceui.AngularUtils.applyingQ($q, $rootScope), cacheBusting: atex.aceui.BrowserUtils.isSafariBrowser() };
          serviceHandler = atex.aceui.service.WorkflowService(serviceUrl, serviceSettings);

          return serviceHandler;
        });
      };

      return {
        initialize: ({ target, workflowId, alias, comment, revision }) => {
          return AuthenticationService.callWithAuthentication ((user) => {
            return handler().then((workflowService) => {
              return workflowService.initialize ({
                token: user.token,
                target,
                workflowId,
                alias,
                comment,
                revision
              });
            });
          });
        },

        transition: ({ target, workflowId, alias, comment, revision }) => {
          return AuthenticationService.callWithAuthentication ((user) => {
            return handler().then((workflowService) => {
              return workflowService.transition ({
                token: user.token,
                target,
                workflowId,
                alias,
                comment,
                revision
              });
            });
          });
        },

        abort: ({ workflowId, alias, comment, revision }) => {
          return AuthenticationService.callWithAuthentication ((user) => {
            return handler().then((workflowService) => {
              return workflowService.abort ({
                token: user.token,
                workflowId,
                alias,
                comment,
                revision
              });
            });
          });
        },

        getWorkflow: ({ workflowId }) => {
          return AuthenticationService.callWithAuthentication ((user) => {
            return handler().then((workflowService) => {
              return workflowService.getWorkflow ({
                token: user.token,
                workflowId
              });
            });
          });
        },

        getWorkflowFor: ({ contentType }) => {
          return AuthenticationService.callWithAuthentication ((user) => {
            return handler().then((workflowService) => {
              return workflowService.getWorkflowFor ({
                token: user.token,
                contentType
              });
            });
          });
        },

        isAllowed: (transition, user, authorizationInfo, securityContexts) => {
          if (transition.allowedBy) {
            let contexts = securityContexts && securityContexts.length > 0 ? securityContexts : ['__global__'];

            let found = contexts.find(context => {
              return transition.allowedBy.find((role) => {
                return (authorizationInfo.contexts[context] || []).includes(role);
              });
            });

            return !!found;
          }

          return true;
        },

        isEditableBy: (workflowState, user, authorizationInfo, securityContexts) => {
          let editableBy = workflowState.editableBy;
          let contexts = securityContexts && securityContexts.length > 0 ? securityContexts : ['__global__'];

          let isEditableBy = editableBy ?
            contexts.find((context) => {
              return editableBy.find((role) => {
                return (authorizationInfo.contexts[context] || []).includes(role);
              });
            })
            : false;

          return !!isEditableBy;
        }
      };
    }
  ]
);
